import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from '../../../../redux/auth/authActions'
import { ROLES } from '../../../../data/roles'

import { Row, Col, Form, Input, Button, Checkbox, Alert } from "antd";

import LeftContent from "../leftContent";
import Footer from "../footer";
import { instance } from '../../../../data/api'

export default function Login() {

  const dispatch = useDispatch();
  const history = useHistory();

  const [errorMessage, setErrorMessage] = React.useState("");

  const submitForm = (values) => {
    instance.post("auth/login.php", {
      ...values,
      codice: values?.codice?.toUpperCase()
    }).then((b) => {
      if (b.data?.data?.token) {
        localStorage.setItem("authkey", b.data?.data?.token)


        dispatch(login({
          role: ROLES[b?.data?.data?.user?.IdTipoUtente], azienda: {
            logo: b?.data?.data?.azienda?.Logo,
            nome: b?.data?.data?.azienda?.Nome
          }
        }));
        history.replace("/")
      }

    }).catch((r) => {
      setErrorMessage(r?.response?.data?.message || "Impossibile accedere, riprova piu tardi")
    })
  }

  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">
      <LeftContent />

      <Col lg={12} span={24} className="hp-py-sm-0 hp-py-md-64">
        <Row className="hp-h-100" align="middle" justify="center">
          <Col
            xxl={11}
            xl={15}
            lg={20}
            md={20}
            sm={24}
            className="hp-px-sm-8 hp-pt-24 hp-pb-48"
          >
            <h1 className="hp-mb-sm-0">Login</h1>
            <p className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-60">
              Bentornato! Perfavore accedi per continuare.
            </p>
            {errorMessage &&
              <Alert type="error" message={errorMessage} />
            }

            <Form
              layout="vertical"
              name="basic"
              initialValues={{ remember: true }}
              className="hp-mt-sm-16 hp-mt-32"
              onFinish={submitForm}
              onFinishFailed={console.log}
            >
              <Form.Item label="Codice azienda:" name="codice" className="hp-mb-16" rules={[{ required: true, message: "Inserisci il codice" }]}>
                <Input />
              </Form.Item>

              <Form.Item label="Username:" name="username" className="hp-mb-16" rules={[{ required: true, message: "Inserisci il tuo username" }]}>
                <Input />
              </Form.Item>

              <Form.Item label="Password:" name="password" className="hp-mb-8" rules={[{ required: true, message: "Inserisci la password" }]}>
                <Input.Password />
              </Form.Item>

              <Row align="middle" justify="space-between">
                <Form.Item className="hp-mb-0">
                  <Checkbox name="remember">Ricordami</Checkbox>
                </Form.Item>

                <Link
                  className="hp-button hp-text-color-black-80 hp-text-color-dark-40"
                  to="/pages/authentication/recover-password"
                >
                  Password dimenticata?
                </Link>
              </Row>

              <Form.Item className="hp-mt-16 hp-mb-8">
                <Button block type="primary" htmlType="submit">
                  Accedi
                </Button>
              </Form.Item>
            </Form>

            <Footer />
          </Col>
        </Row>
      </Col >
    </Row >
  );
};